
export * from './lib/theme-color-palette';
